export const getAllApprovalLikelihoodsEndpoint = 'approval-likelihoods';
